import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { Column, TableColumnSelectorService } from '../table-column-selector.service';

@Component({
    selector: 'nuso-table-column-selector',
    templateUrl: './table-column-selector.component.html',
    styleUrls: ['./table-column-selector.component.scss'],
    standalone: false
})
export class TableColumnSelectorComponent {
  private dialogRef = inject<MatDialogRef<TableColumnSelectorComponent>>(MatDialogRef);
  private tableColumnSelectorService = inject(TableColumnSelectorService);
  data = inject<{
    columns: Column[];
    selectedColumns: string[];
    disabledColumns?: string[];
    title?: string;
    subtitle?: string;
    storageKey: string;
    sortable?: boolean;
}>(MAT_DIALOG_DATA);

  outData$ = new Subject<{ selectedColumns: string[] }>();

  constructor() {
    if (!this.data.title) this.data.title = 'Columns to display';
    if (!this.data.subtitle) this.data.subtitle = 'Select the columns to display in the table';
    if (!this.data.disabledColumns) this.data.disabledColumns = [];
    this.data.sortable = this.data.sortable ?? false;
  }

  isColumnDisabled(columnId: string): boolean {
    return (this.data.disabledColumns ?? []).includes(columnId);
  }

  onSave() {
    // save selectedColumns to localStorage
    this.tableColumnSelectorService.setSelectedColumns(this.data.storageKey, this.data.selectedColumns);

    this.outData$.next({ selectedColumns: this.data.selectedColumns });
    this.outData$.complete();
    this.closeDialog();
  }

  dropOnGroup(event: CdkDragDrop<Column[]>) {
    const prevIndex = event.previousIndex;
    const currIndex = event.currentIndex;

    // If the item was dropped in the same place, do nothing
    if (prevIndex === currIndex) return;

    // Perform the actual move operation using array manipulation
    const columnToMove = this.data.columns.splice(prevIndex, 1)[0];
    this.data.columns.splice(currIndex, 0, columnToMove);

    // reorder selectedColumns to match the new order in columns
    const selectedSet = new Set(this.data.selectedColumns);
    this.data.selectedColumns = this.data.columns.filter((col) => selectedSet.has(col.id)).map((col) => col.id);
  }

  private closeDialog() {
    this.dialogRef.close();
  }
}
